import Comments from 'components/Comments';
import type { KeyValueCallback } from 'types/utils.type';
import type { TAvailabilityRelationType } from '@timeedit/types';
import GeneralInfo from './sections/GeneralInfo';
import Properties from './sections/Properties';

interface Props {
  availabilityRelation: TAvailabilityRelationType;
  onChange: KeyValueCallback<TAvailabilityRelationType>;
}

const AvailabilityRelation = ({ availabilityRelation, onChange }: Props) => {
  if (!availabilityRelation) return null;
  return (
    <>
      <GeneralInfo
        availabilityRelation={availabilityRelation}
        onChange={onChange}
      />
      <Properties
        availabilityRelation={availabilityRelation}
        onChange={onChange}
      />
      <Comments
        value={availabilityRelation.description}
        onChange={(val) => onChange('description', val)}
      />
    </>
  );
};

export default AvailabilityRelation;
